// extracted by mini-css-extract-plugin
module.exports = {"text":"title-s_text__25g8T"};